import { useEffect } from "react";

import { useDispatch } from "react-redux";

import {
  handleOnStateChangeEvent,
  handleManualProfileUpdatedEvent,
  handleCleaningProfileUpdatedEvent,
  handleOnDeviceFailureEvent,
  handleOnRecoveryStatusUpdatedEvent,
  handleOnAutoProfileUpdatedEvent,
  handleOnCycleTimesUpdatedEvent,
  handleOnManualControlStatusUpdatedEvent,
  handleOnDiafiltrationStatusUpdatedEvent,
  handleOnVolumeThresholdErrorEvent,
  handleOnLicenseExpiredEvent,
  setDeviceHubConnection,
  handleOnDelayProfilePreparationEvent,
  handleOnDelayProfileStartEvent,
  handleOnDeviceLockUpdated,
} from "@/businesses/deviceHubBusiness";
import { SignalRHub } from "@/constants/dataEnum";
import deviceHubObserver from "@/observers/deviceHubObserver";
import { buildHub } from "@/websocket/hubBuilder";

function useDeviceHubObserver() {
  const dispatch = useDispatch();

  useEffect(() => {
    const onDeviceHubConnStateHandler = (...args) =>
      dispatch(setDeviceHubConnection(...args));
    const onStateChange = (...args) =>
      dispatch(handleOnStateChangeEvent(...args));
    const manualProfileUpdated = (...args) =>
      dispatch(handleManualProfileUpdatedEvent(...args));
    const cleaningProfileUpdated = (...args) =>
      dispatch(handleCleaningProfileUpdatedEvent(...args));
    const onDeviceFailure = (...args) =>
      dispatch(handleOnDeviceFailureEvent(...args));
    const onRecoveryStatusUpdated = (...args) =>
      dispatch(handleOnRecoveryStatusUpdatedEvent(...args));
    const onAutoProfileUpdated = (...args) =>
      dispatch(handleOnAutoProfileUpdatedEvent(...args));
    const onCycleTimesUpdated = (...args) =>
      dispatch(handleOnCycleTimesUpdatedEvent(...args));
    const onManualControlStatusUpdated = (...args) =>
      dispatch(handleOnManualControlStatusUpdatedEvent(...args));
    const onDiafiltrationStatusUpdated = (...args) =>
      dispatch(handleOnDiafiltrationStatusUpdatedEvent(...args));
    const onVolumeThresholdError = (...args) =>
      dispatch(handleOnVolumeThresholdErrorEvent(...args));
    const onLicenseExpired = (...args) =>
      dispatch(handleOnLicenseExpiredEvent(...args));
    const onDelayProfilePreparation = (...args) =>
      dispatch(handleOnDelayProfilePreparationEvent(...args));
    const onDelayProfileStart = (...args) =>
      dispatch(handleOnDelayProfileStartEvent(...args));
    const onDeviceLockUpdated = (...args) =>
      dispatch(handleOnDeviceLockUpdated(...args));

    // #region add Observer
    deviceHubObserver.add.connStateHandler(onDeviceHubConnStateHandler);
    deviceHubObserver.add.onStateChange(onStateChange);
    deviceHubObserver.add.manualProfileUpdated(manualProfileUpdated);
    deviceHubObserver.add.cleaningProfileUpdated(cleaningProfileUpdated);
    deviceHubObserver.add.onDeviceFailure(onDeviceFailure);
    deviceHubObserver.add.onRecoveryStatusUpdated(onRecoveryStatusUpdated);
    deviceHubObserver.add.onAutoProfileUpdated(onAutoProfileUpdated);
    deviceHubObserver.add.onCycleTimesUpdated(onCycleTimesUpdated);
    deviceHubObserver.add.onManualControlStatusUpdated(
      onManualControlStatusUpdated
    );
    deviceHubObserver.add.onDiafiltrationStatusUpdated(
      onDiafiltrationStatusUpdated
    );
    deviceHubObserver.add.onVolumeThresholdError(onVolumeThresholdError);
    deviceHubObserver.add.onLicenseExpired(onLicenseExpired);
    deviceHubObserver.add.onDelayProfilePreparation(onDelayProfilePreparation);
    deviceHubObserver.add.onDelayProfileStart(onDelayProfileStart);
    deviceHubObserver.add.onDeviceLockUpdated(onDeviceLockUpdated);

    // #endregion

    // #region build hub
    buildHub(SignalRHub.DEVICE);
    // #endregion
    return () => {
      // TO-DO: Create unmount.
      deviceHubObserver.remove.connStateHandler(onDeviceHubConnStateHandler);
      deviceHubObserver.remove.onStateChange(onStateChange);
      deviceHubObserver.remove.manualProfileUpdated(manualProfileUpdated);
      deviceHubObserver.remove.cleaningProfileUpdated(cleaningProfileUpdated);
      deviceHubObserver.remove.onDeviceFailure(onDeviceFailure);
      deviceHubObserver.remove.onRecoveryStatusUpdated(onRecoveryStatusUpdated);
      deviceHubObserver.remove.onAutoProfileUpdated(onAutoProfileUpdated);
      deviceHubObserver.remove.onCycleTimesUpdated(onCycleTimesUpdated);
      deviceHubObserver.remove.onManualControlStatusUpdated(
        onManualControlStatusUpdated
      );
      deviceHubObserver.remove.onDiafiltrationStatusUpdated(
        onDiafiltrationStatusUpdated
      );
      deviceHubObserver.remove.onVolumeThresholdError(onVolumeThresholdError);
      deviceHubObserver.remove.onLicenseExpired(onLicenseExpired);
      deviceHubObserver.remove.onDelayProfilePreparation(
        onDelayProfilePreparation
      );
      deviceHubObserver.remove.onDelayProfileStart(onDelayProfileStart);
      deviceHubObserver.remove.onDeviceLockUpdated(onDeviceLockUpdated);
    };
  }, [dispatch]);
}
export default useDeviceHubObserver;
